<!--contact section start-->
<footer class="event contact set-relative bg bg-img bg-about p-b-0" id="contact" [ngStyle]="{'background-image': 'url(assets/images/event/bg1.jpg)'}">
    <div class="container p-b-150">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <div class="title title3">
                    <div class="main-title">
                        <h2 class=" text-white">About the Event</h2>
                    </div>
                </div>
            </div>
            <div class="col-md-7 p-r-0 map">
                <div class="iframe-container">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.8555029520694!2d121.0561214!3d14.5502545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397c8f2ca652c83%3A0x62c8011c6abe662e!2sMarket*21%20Market*21!5e0!3m2!1sen!2sph!4v1753202868627!5m2!1sen!2sph" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
            <div class="col-md-5">
                <img src="assets/images/event/about.jpg" alt="" class="about-image">
            </div>
        </div>
    </div>
</footer>
<!--contact section end-->
